export default __webpack_public_path__ + "1.18.25/static/media/LibreDataSharecode_Hebrew.805f02e2.svg";